import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
  width: 100%;
  height: 100%;
}

.document-preview {
  width: 100%;
  height: 100%;
}

.stage {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  background-color: var(--p-bg);
}

img{
  display: block;
}

/**
--------------------------------------------------
* Full page
--------------------------------------------------
*/
.stage.full-page .page{
  padding: var(--p-gap);
  height: 100%;
  display: flex;
  justify-content: center;
  overflow: hidden;
}

.stage.full-page .page img{
  width:100%;
  height: 100%;
  object-fit: contain;
  filter: drop-shadow(0px 0px 15px rgba(0,0,0,.1));
}


`;
